<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:new="newHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import PayItemForm from "../../../components/payroll/payitem/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PayItemForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setuppayitem.editpayitem'),
      pageTitleValue: "",

      formData: [],
 
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadPayItemHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/payitem/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          if (res.data.rec[0].startdate) {
            vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
            vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

          // convert Y/N to boolean
          if (res.data.rec[0].cofringe == "Y") {
            vm.formData.cofringe = true;
          } else {
            vm.formData.cofringe = false;
          }

          if (res.data.rec[0].arritem == "Y") {
            vm.formData.arritem = true;
          } else {
            vm.formData.arritem = false;
          }

          if (res.data.rec[0].basdep == "Y") {
            vm.formData.basdep = true;
          } else {
            vm.formData.basdep = false;
          }

          if (res.data.rec[0].regitem == "Y") {
            vm.formData.regitem = true;
          } else {
            vm.formData.regitem = false;
          }


           vm.formData.lockstaff = res.data.rec[0].lockstaff;

          vm.pageTitleValue = res.data.rec[0].payitemdesc;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      // change boolean to int
      if (this.formData.cofringe == true) {
        this.formData.cofringe = 1;
      } else {
        this.formData.cofringe = 0;
      }

      if (this.formData.arritem == true) {
        this.formData.arritem = 1;
      } else {
        this.formData.arritem = 0;
      }

      if (this.formData.basdep == true) {
        this.formData.basdep = 1;
      } else {
        this.formData.basdep = 0;
      }

      if (this.formData.regitem == true) {
        this.formData.regitem = 1;
      } else {
        this.formData.regitem = 0;
      }


    // if (typeof vm.formData.taxexemptionid == "undefined")
    // {
    //   vm.formData.taxexemptionid = null;
    // }
      this.$store.dispatch('put', {url: "/payitem/" + this.id, payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "payitemlist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/payitem/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    newHandler() {
      this.$router.push({ name: "payitemnew" });
    },
  },

  async mounted() {
    await this.loadPayItemHandler();
  },
};
</script>